import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy `/<lang>/explore/<city>` → 301 to canonical `/<lang>/place/<city>`.
 *
 * The city hub lives at `/<lang>/place/<city>`; the old `/explore/<city>`
 * URL was linked from the home page and indexed. We redirect with 301 so
 * external incoming links and crawlers consolidate on the canonical hub.
 */
export const Route = createFileRoute("/$lang/_layout/explore/$city/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/$lang/place/$city",
      params: { lang: params.lang, city: params.city },
      replace: true,
      statusCode: 301,
    });
  },
});
